/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_Article_Chat_Commands_TitleInputs */



/**
* | output |
* | --- |
* | "Card Lookups in Chat" |
*
* @param {Help_Article_Chat_Commands_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const help_article_chat_commands_title = /** @type {((inputs?: Help_Article_Chat_Commands_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_Article_Chat_Commands_TitleInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Kartensuche im Chat")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Recherche de cartes dans le chat")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("在聊天中查卡")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("聊天室查卡")
	if (locale === "ko") return /** @type {LocalizedString} */ ("채팅에서 카드 조회하기")
	return /** @type {LocalizedString} */ ("Card Lookups in Chat")
});